import * as React from 'react';
import { pipe } from 'fp-ts/lib/function';
import * as A from 'fp-ts/lib/Array';
import * as O from 'fp-ts/lib/Option';
import { useIORef } from '../../core/hooks';
import { useSetter, useEffect } from './slots';

type Unit = { id: number } & Record<string, any>;

export type Value = Unit[] | null;

type Props = {
    value: Value,
}

export default ({ value }: Props) => {
    const [, run] = useEffect('multiChange');
    const { read: get, write, modify } = useIORef<Unit[]>(value || []);

    const append = React.useCallback(run((x: Unit) => {
        modify(xs => xs.concat([x]))();
    }), []);

    const removeAt = React.useCallback(run((id: number) => {
        modify(xs => pipe(
            xs,
            A.findIndex(x => x.id === id),
            O.chain(index => A.deleteAt(index)(xs)),
            O.fold(
                () => xs,
                (r) => r,
            )
        ))();
    }), []);

    const clear = React.useCallback(run(() => {
        write([])();
    }), []);

    useSetter('multi', {
        get,
        append,
        removeAt,
        clear,
    });

    return null;
};
